import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const auth = createSlice({
  name: "auth",
  initialState: {
    loginData: null,
    loggedIn: !!Cookies.get("access_token"),
    prevUrl: "",
    needRedirect: false,
    profile: null,
  },
  reducers: {
    loginUser(state, { payload }) {
      const expires = new Date();
      expires.setTime(expires.getTime() + 30 * 24 * 60 * 60 * 1000);
      state.profile = payload?.profile;
      state.loginData = payload?.token;
      state.needRedirect = true;
      state.loggedIn = true;
      Cookies.set("video_token", payload?.token?.access_token, {
        domain: ".dadbanan.com",
        expires,
        secure: true,
        sameSite: "None",
      });
      Cookies.set("access_token", payload?.token?.access_token, {
        expires,
      });
      Cookies.set("refresh_token", payload?.token?.refresh_token, {
        expires,
      });
    },
    prevUrlBeforAuth(state, { payload }) {
      state.prevUrl = payload.path;
      state.needRedirect = payload.needRedirect;
    },
    logout(state, action) {
      Cookies.remove("access_token");
      Cookies.remove("refresh_token");
      Cookies.remove("video_token");
      state.loggedIn = false;
      state.loginData = null;
      state.profile = null;
    },
    setProfile(state, { payload }) {
      state.profile = payload;
    },
    setLoginData(state, { payload }) {
      state.loginData = payload;
    },
  },
});

export const { loginUser, prevUrlBeforAuth, setProfile, setLoginData, logout } =
  auth.actions;

export default auth.reducer;
